/**
 * Dependencies
 */
import Vue from 'vue';
import axios from 'axios';
import lodash from 'lodash';

/**
 * Components
 */
import Product from './components/Product';
import vSelect from 'vue-select';
Vue.component('v-select', vSelect);


/**
 * Polyfill
 */
// const queryString = require('query-string');
require('intersection-observer');

/**
 * Vue instance
 */
export default (() => {
    // Check for DOM element
    if (!document.querySelector('#favourite-products')) return false;

    return new Vue({
        el: '#favourite-products',

        components: {
            product: Product,
            vSelect,
        },

        data: {
            loading: true,
            api: {
                productsRequest: null,
            },
            csrfToken: '',
            ownerId: '',
            companyId: '',
            activeProductManufacturer: 'all',
            products: [],
            productTypes: ['all', 'inverter', 'pvModule'],
            productManufacturers: [],
            activeProductType: 'all',

        },

        computed: {

            filteredProducts: function () {
                let resultProducts = [...this.products];

                if(this.activeProductType !== 'all'){
                    resultProducts = lodash.filter( resultProducts, ['type', this.activeProductType] );
                }

                if(this.activeProductManufacturer !== 'all'){
                    resultProducts = lodash.filter( resultProducts, ['manufacturer', this.activeProductManufacturer] );
                }

                return resultProducts;
            },

            filterManufacturers: function () {
                let resultManufacturers = [...this.products];

                if(this.activeProductType !== 'all'){
                    resultManufacturers = lodash.filter( resultManufacturers, ['type', this.activeProductType] );
                    resultManufacturers = lodash.uniq(lodash.map(resultManufacturers, 'manufacturer'));
                    resultManufacturers.unshift('all');
                }else{
                    resultManufacturers = lodash.uniq(lodash.map(resultManufacturers, 'manufacturer'));
                    resultManufacturers.unshift('all');
                }

                return resultManufacturers;
            },


        },

        mounted() {
            // set static vars
            this.ownerId = this.$el.attributes['data-owner-id'].value;
            this.companyId = this.$el.attributes['data-company-id'].value;
            this.csrfToken = window.csrfTokenValue;

            // Set products request URL
            this.api.productsRequest = `/api/user/products.json`;


            // Init requests
            axios.all([
                this.getProducts(this.api.productsRequest),
            ])
            .then(axios.spread((products) => {
                // Update propertes
                this.products = products;

                // Update loading state
                this.loading = false;
            }));

        },

        methods: {
            /**
             * Get Product data
             * @param {string} requestURL The API endpoint
             */
            getProducts(requestURL) {
                return axios.get(requestURL)
                    // Get data
                    .then((response) => {
                        // Return data to next then
                        return response.data.data.products;
                    });
            },
            setActiveProductType(value) {
                this.activeProductType = value;
                this.activeProductManufacturer = 'all';
                // console.log(this.activeProductType, this.products); // eslint-disable-line
            },
            setActiveProductManufacturer(value) {
                this.activeProductManufacturer = value;
            }
        },
    });
})();
